"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatorApi = exports.CalculatorApiFactory = exports.CalculatorApiFp = exports.CalculatorApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
const common_1 = require("../common");
const base_1 = require("../base");
const CalculatorApiAxiosParamCreator = function (configuration) {
    return {
        esyoilAPIEntryPointsCalculatorAveragePricesBundesland: async (options = {}) => {
            const localVarPath = `/v1/calculator/bundesland/average`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorGetCityPrices: async (options = {}) => {
            const localVarPath = `/v1/calculator/city-prices`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorGetCurrentAveragePrice: async (options = {}) => {
            const localVarPath = `/v1/calculator/current-average`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorGetHistoryPricingData: async (zipcode, date, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorGetHistoryPricingData', 'zipcode', zipcode);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorGetHistoryPricingData', 'date', date);
            const localVarPath = `/v1/calculator/history-pricing/{zipcode}/{date}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorHistoryTable: async (zipcode, min, max, step, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorHistoryTable', 'zipcode', zipcode);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorHistoryTable', 'min', min);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorHistoryTable', 'max', max);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorHistoryTable', 'step', step);
            const localVarPath = `/v1/calculator/history-table/{zipcode}/{min}/{max}/{step}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)))
                .replace(`{${"min"}}`, encodeURIComponent(String(min)))
                .replace(`{${"max"}}`, encodeURIComponent(String(max)))
                .replace(`{${"step"}}`, encodeURIComponent(String(step)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorHistoryTendency: async (zipcode, date, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorHistoryTendency', 'zipcode', zipcode);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorHistoryTendency', 'date', date);
            const localVarPath = `/v1/calculator/history/{zipcode}/{date}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)))
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorParams: async (zipcode, amount, up, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorParams', 'zipcode', zipcode);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorParams', 'amount', amount);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorParams', 'up', up);
            const localVarPath = `/v1/calculator/params/{zipcode}/{amount}/{up}`
                .replace(`{${"zipcode"}}`, encodeURIComponent(String(zipcode)))
                .replace(`{${"amount"}}`, encodeURIComponent(String(amount)))
                .replace(`{${"up"}}`, encodeURIComponent(String(up)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorRatePayAGB: async (options = {}) => {
            const localVarPath = `/v1/calculator/ratepay/agb`;
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorRatePayCheck: async (productID, token, firstname, lastname, gender, birthday, ip, email, phone, street, streetnumber, zipcode, city, hasDeliveryAdress, zipcodeDelivery, cityDelivert, transactionId, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorRatePayCheck', 'productID', productID);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorRatePayCheck', 'token', token);
            const localVarPath = `/v1/calculator/ratepaycheck/{productID}/{token}`
                .replace(`{${"productID"}}`, encodeURIComponent(String(productID)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new URLSearchParams();
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (firstname !== undefined) {
                localVarFormParams.set('firstname', firstname);
            }
            if (lastname !== undefined) {
                localVarFormParams.set('lastname', lastname);
            }
            if (gender !== undefined) {
                localVarFormParams.set('gender', gender);
            }
            if (birthday !== undefined) {
                localVarFormParams.set('birthday', birthday);
            }
            if (ip !== undefined) {
                localVarFormParams.set('ip', ip);
            }
            if (email !== undefined) {
                localVarFormParams.set('email', email);
            }
            if (phone !== undefined) {
                localVarFormParams.set('phone', phone);
            }
            if (street !== undefined) {
                localVarFormParams.set('street', street);
            }
            if (streetnumber !== undefined) {
                localVarFormParams.set('streetnumber', streetnumber);
            }
            if (zipcode !== undefined) {
                localVarFormParams.set('zipcode', zipcode);
            }
            if (city !== undefined) {
                localVarFormParams.set('city', city);
            }
            if (hasDeliveryAdress !== undefined) {
                localVarFormParams.set('hasDeliveryAdress', hasDeliveryAdress);
            }
            if (zipcodeDelivery !== undefined) {
                localVarFormParams.set('zipcode_delivery', zipcodeDelivery);
            }
            if (cityDelivert !== undefined) {
                localVarFormParams.set('city_delivert', cityDelivert);
            }
            if (transactionId !== undefined) {
                localVarFormParams.set('transaction_id', transactionId);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams.toString();
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorRatePayFingerprint: async (token, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorRatePayFingerprint', 'token', token);
            const localVarPath = `/v1/calculator/ratepay/fingerprint/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        esyoilAPIEntryPointsCalculatorRatePayRates: async (price, token, options = {}) => {
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorRatePayRates', 'price', price);
            common_1.assertParamExists('esyoilAPIEntryPointsCalculatorRatePayRates', 'token', token);
            const localVarPath = `/v1/calculator/ratepayrates/{price}/{token}`
                .replace(`{${"price"}}`, encodeURIComponent(String(price)))
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            await common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CalculatorApiAxiosParamCreator = CalculatorApiAxiosParamCreator;
const CalculatorApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.CalculatorApiAxiosParamCreator(configuration);
    return {
        async esyoilAPIEntryPointsCalculatorAveragePricesBundesland(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorAveragePricesBundesland(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorGetCityPrices(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorGetCityPrices(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorGetCurrentAveragePrice(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorGetCurrentAveragePrice(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorGetHistoryPricingData(zipcode, date, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorGetHistoryPricingData(zipcode, date, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorHistoryTable(zipcode, min, max, step, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorHistoryTable(zipcode, min, max, step, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorHistoryTendency(zipcode, date, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorHistoryTendency(zipcode, date, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorParams(zipcode, amount, up, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorParams(zipcode, amount, up, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorRatePayAGB(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorRatePayAGB(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorRatePayCheck(productID, token, firstname, lastname, gender, birthday, ip, email, phone, street, streetnumber, zipcode, city, hasDeliveryAdress, zipcodeDelivery, cityDelivert, transactionId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorRatePayCheck(productID, token, firstname, lastname, gender, birthday, ip, email, phone, street, streetnumber, zipcode, city, hasDeliveryAdress, zipcodeDelivery, cityDelivert, transactionId, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorRatePayFingerprint(token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorRatePayFingerprint(token, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        async esyoilAPIEntryPointsCalculatorRatePayRates(price, token, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.esyoilAPIEntryPointsCalculatorRatePayRates(price, token, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.CalculatorApiFp = CalculatorApiFp;
const CalculatorApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.CalculatorApiFp(configuration);
    return {
        esyoilAPIEntryPointsCalculatorAveragePricesBundesland(options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorAveragePricesBundesland(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorGetCityPrices(options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorGetCityPrices(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorGetCurrentAveragePrice(options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorGetCurrentAveragePrice(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorGetHistoryPricingData(zipcode, date, options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorGetHistoryPricingData(zipcode, date, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorHistoryTable(zipcode, min, max, step, options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorHistoryTable(zipcode, min, max, step, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorHistoryTendency(zipcode, date, options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorHistoryTendency(zipcode, date, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorParams(zipcode, amount, up, options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorParams(zipcode, amount, up, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorRatePayAGB(options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorRatePayAGB(options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorRatePayCheck(productID, token, firstname, lastname, gender, birthday, ip, email, phone, street, streetnumber, zipcode, city, hasDeliveryAdress, zipcodeDelivery, cityDelivert, transactionId, options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorRatePayCheck(productID, token, firstname, lastname, gender, birthday, ip, email, phone, street, streetnumber, zipcode, city, hasDeliveryAdress, zipcodeDelivery, cityDelivert, transactionId, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorRatePayFingerprint(token, options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorRatePayFingerprint(token, options).then((request) => request(axios, basePath));
        },
        esyoilAPIEntryPointsCalculatorRatePayRates(price, token, options) {
            return localVarFp.esyoilAPIEntryPointsCalculatorRatePayRates(price, token, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CalculatorApiFactory = CalculatorApiFactory;
class CalculatorApi extends base_1.BaseAPI {
    esyoilAPIEntryPointsCalculatorAveragePricesBundesland(options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorAveragePricesBundesland(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorGetCityPrices(options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorGetCityPrices(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorGetCurrentAveragePrice(options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorGetCurrentAveragePrice(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorGetHistoryPricingData(zipcode, date, options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorGetHistoryPricingData(zipcode, date, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorHistoryTable(zipcode, min, max, step, options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorHistoryTable(zipcode, min, max, step, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorHistoryTendency(zipcode, date, options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorHistoryTendency(zipcode, date, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorParams(zipcode, amount, up, options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorParams(zipcode, amount, up, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorRatePayAGB(options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorRatePayAGB(options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorRatePayCheck(productID, token, firstname, lastname, gender, birthday, ip, email, phone, street, streetnumber, zipcode, city, hasDeliveryAdress, zipcodeDelivery, cityDelivert, transactionId, options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorRatePayCheck(productID, token, firstname, lastname, gender, birthday, ip, email, phone, street, streetnumber, zipcode, city, hasDeliveryAdress, zipcodeDelivery, cityDelivert, transactionId, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorRatePayFingerprint(token, options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorRatePayFingerprint(token, options).then((request) => request(this.axios, this.basePath));
    }
    esyoilAPIEntryPointsCalculatorRatePayRates(price, token, options) {
        return exports.CalculatorApiFp(this.configuration).esyoilAPIEntryPointsCalculatorRatePayRates(price, token, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CalculatorApi = CalculatorApi;
//# sourceMappingURL=calculator-api.js.map